<template>
  <span>
    There is an error. <a
      :href="`mailto:${emailTo}${subject}`"
      class="contact-us-link"
    >Contact us</a> for more information.
  </span>
</template>
<script>
import { mapState } from 'pinia';
import { useWizard } from '@/stores/wizard/wizard';

export default {
  name: 'ContactUsTemplate',
  computed: {
    ...mapState(useWizard, {
      emailTo: (store) => store.flash.templateEmail,
      emailToSubject: (store) => store.flash.templateEmailSubject,
    }),
    subject() {
      if (this.emailToSubject) return `?subject=${encodeURI(this.emailToSubject)}`;
      return '';
    },
  },
};
</script>
<style lang="less" scoped>
.contact-us-link {
  font-weight: 500;
}
</style>
